<template>
  <div class="italic text-xs font-medium! opacity-80 text-[var(--p-primary-900)]/60 dark:text-[var(--p-surface-50)]/70">
    {{ content }}
  </div>
</template>

<script setup lang="ts">
interface Props {
  content: string
}

defineProps<Props>()
</script>
